<template>
  <div class="input-wrap" :class="widthClassName">
    <label v-if="label !== 'none'" for=""
      >{{ label }}
      <span v-if="required" class="required">※必須</span>
      <span v-if="isEdit" class="required">※編集できません</span>
    </label>
    <span class="valid" v-if="alert">
      入力項目が空または正しい形式ではありません。</span
    >
    <p class="input-description">{{ description }}</p>
    <input
      :type="type"
      :name="setKey"
      :value="value"
      :placeholder="placeholder"
      :inputmode="inputmode"
      @blur="updateValue"
      maxlength="100"
      :min="min"
      :readonly="readonly"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], required: true, default: null },
    type: { type: String, required: true },
    setKey: { type: String, required: true },
    placeholder: { type: String, required: false },
    alert: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    inputmode: { type: String, required: false },
    min: { type: String, required: false },
    readonly: { type: Boolean, required: false },
    isEdit: { type: Boolean, required: false },
    description: { type: String, required: false },
    widthClassName: { type: String, required: false },
  },
  methods: {
    updateValue(e) {
      this.$emit('input-emit', this.setKey, e.target.value)
    },
  },
}
</script>

<style lang="scss" scoped>
input[readonly] {
  background-color: #d8dbe0;
  opacity: 1;
  outline: none;
}
</style>
